import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { FieldProps } from "react-jsonschema-form";
import { WitLabel } from "../shared/widgets/common";
import MultiCheckboxGroup from "../witadmin/CRUD/Common/MultiCheckBoxGroup";
import { CreatePropertyOptions } from "./domain/createProperty.entity";
import { messages } from "./messages";

export function CreatePropertyOptionsWidget({ schema, formData, onChange }: FieldProps) {
  const intl = useIntl();

  const options = useMemo(
    () => [
      { ticker: CreatePropertyOptions.MIGRATE_ARI, name: intl.formatMessage(messages.migrateAri) },
    ],
    [intl]
  );

  const handleOnChange = useCallback(
    ({ value }: { value: CreatePropertyOptions[] }) => {
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <div>
      <WitLabel>{schema.title}</WitLabel>
      <MultiCheckboxGroup
        className="witadmin-bs3"
        value={formData}
        field={{
          options: options,
        }}
        onChange={handleOnChange}
      />
    </div>
  );
}
